import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import useUser from "./useUser";
import { transformEmployeeDetails } from "../features/employeeManagement/utils/employeeTransformer";
import { useGetEmployeeDetailsQuery } from "../ReduxToolkit/api/employee";
import { useMemo } from "react";

export const useEmployeeProfile = () => {
  const { employeeId } = useParams<{ employeeId: string }>();
  const loggedInEmployee = useUser();
  const id = employeeId ?? loggedInEmployee?.id;

  const result = useGetEmployeeDetailsQuery(id ? String(id) : skipToken);
  const { data, isLoading, refetch, isError, error } = result; // refetch is available here

  const employeeProfileDetails = transformEmployeeDetails(data);

  const loggedInEmployeeRole = useMemo(
    () =>
      loggedInEmployee?.user_type
        ?.trim()
        .toLowerCase()
        .replace(/[\s_]+/g, "") ?? "",
    [loggedInEmployee?.user_type]
  );

  const employeeRole = useMemo(
    () =>
      employeeProfileDetails?.jobInformation?.userType
        ?.trim()
        .toLowerCase()
        .replace(/[\s_]+/g, "") ?? "",
    [employeeProfileDetails?.jobInformation?.userType]
  );

  return {
    id,
    isError,
    error,
    isLoading,
    employeeRole,
    loggedInEmployee,
    loggedInEmployeeRole,
    employeeProfileDetails,
    refetchEmployeeProfile: refetch, 
    profileFetchedAt: result.fulfilledTimeStamp,
  };
};
